import React from 'react';
import { Paper } from '@mui/material';

interface ProjectCardProps {
  imageUrl: string;
  name: string;
  onSelect: () => void;
}

const ProjectCard: React.FC<ProjectCardProps> = ({ 
  imageUrl, 
  name, 
  onSelect 
}) => {
  return (
    <Paper
      component="article"
      elevation={0}
      sx={{
        p: 1,
        textAlign: 'center',
        height: 180,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
        background: 'rgba(30, 41, 59, 0.6)',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(37, 99, 235, 0.15)',
        borderRadius: 3,
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: '-100%',
          width: '100%',
          height: '100%',
          background: 'linear-gradient(90deg, transparent, rgba(37, 99, 235, 0.08), transparent)',
          transition: 'left 0.6s ease',
        },
        '&:hover': {
          transform: 'translateY(-8px) scale(1.02)',
          border: '1px solid rgba(37, 99, 235, 0.4)',
          boxShadow: '0 20px 40px rgba(37, 99, 235, 0.15)',
          '&::before': {
            left: '100%',
          },
        },
        '&:focus-visible': {
          transform: 'translateY(-8px) scale(1.02)',
          border: '1px solid rgba(37, 99, 235, 0.6)',
          boxShadow: '0 0 0 3px rgba(37, 99, 235, 0.2)',
          outline: 'none',
        },
      }}
      tabIndex={0}
      role="button"
      aria-label={`Projet ${name}`}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onSelect();
        }
      }}
      onClick={onSelect}
    >
      <img
        src={imageUrl}
        alt={`Logo du projet ${name}`}
        style={{
          width: 'calc(100% - 5px)',
          height: 'calc(100% - 5px)',
          maxWidth: '140px',
          maxHeight: '140px',
          objectFit: 'contain',
          filter: 'drop-shadow(0 4px 8px rgba(37, 99, 235, 0.2))',
          transition: 'all 0.3s ease',
        }}
      />
    </Paper>
  );
};

export default ProjectCard;
